import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';

export const PanelDeleteMenuItem = ({onSelect}: {onSelect: () => void}) => {
  return (
    <DropdownMenu.Item className="hover:bg-red-300/[.48]" onSelect={onSelect}>
      <Icon name="delete" />
      Delete panel
    </DropdownMenu.Item>
  );
};
